// import * as Config from "@/config/config.js";
import area from "../data/area";
import moment from "moment";
/**
 * 工具类
 */

/**
 * 深度复制对象
 * @param obj
 * @returns {any}
 */
export const copyObj = function (obj) {
    if (empty(obj)) return obj;
    return jsonDecode(jsonEncode(obj));
}

/**
 * 判斷是否為空
 * @returns {boolean}
 */
export const empty = function (d) {
    if (
        typeof (d) === 'undefined' ||
        d === null ||
        d === 'null' ||
        d === 'NULL' ||
        d === '' ||
        d === 'undefined'
    ) {
        return true;
    }
    
    // 检查空数组
    if (Array.isArray(d) && d.length === 0) {
        return true;
    }
    
    // 检查空对象
    if (typeof d === 'object' && !Array.isArray(d)) {
        try {
            // 先尝试安全的方式检查对象是否为空
            if (Object.keys(d).length === 0) {
                return true;
            }
        } catch (e) {
            // 如果遇到循环引用，使用备选方案
            try {
                // 使用 WeakSet 检测循环引用
                const seen = new WeakSet();
                const isEmpty = (function checkEmpty(obj) {
                    if (obj && typeof obj === 'object') {
                        if (seen.has(obj)) return true; // 循环引用，认为是非空
                        seen.add(obj);
                        return Object.keys(obj).length === 0;
                    }
                    return false;
                })(d);
                return isEmpty;
            } catch (error) {
                // 如果还是出错，保守返回 false
                return false;
            }
        }
    }
    
    return false;
}

/**
 * 链式读取对象属性
 * @param obj
 * @param key 示例：orderInfo.memberInfo.name
 * @returns {any}
 */
export const getProperty = function (obj, key) {
    if (empty(obj)) return null;
    let keyArr = key.split('.');

    let value = copyObj(obj);
    for (let i in keyArr) {
        if (empty(value[keyArr[i]])) return null;
        value = value[keyArr[i]];
    }
    return value;
}

/**
 * 文本超出隐藏
 * @param str
 * @param len
 * @returns {string|*}
 */
export const textEllipsis = function (str, len) {
    if (empty(len)) return str;
    let str_len = str.length;
    let re_str = str;
    if (str_len > len) {
        re_str = str.substring(0, len) + "...";
    }
    return re_str;
}

/**
 * 数组添加(防重复，重复的则删除)
 * @param arr
 * @param id
 * @returns {*}
 */
export const arrayChange = function (arr, id) {
    let index = arr.indexOf(id);
    if (index >= 0) {
        arr.splice(index, 1);
    } else {
        arr.push(id);
    }
    return arr;
}

/**
 * 对象长度
 * @param obj
 */
export const objLength = function (obj) {
    if (empty(obj)) return 0;
    let num = 0;
    obj.forEach(() => {
        num++;
    })
    return num;
}

/**
 * 倒计时显示
 */
export const formatCountDown = function (end, now) {
    let diff = 0;
    if (empty(now)) now = parseInt(new Date().getTime() / 1000);
    if (!empty(now) && !empty(end) && end > now) diff = end - now;

    let min_sec = 60;
    let hour_sec = 60 * min_sec;
    let day_sec = 24 * hour_sec;

    let d = parseInt(diff / day_sec);
    diff %= day_sec;

    let h = parseInt(diff / hour_sec);
    if (h < 10) h = '0' + h;
    diff %= hour_sec;

    let m = parseInt(diff / min_sec);
    if (m < 10) m = '0' + m;
    diff %= min_sec;

    let s = diff;
    if (s < 10) s = '0' + s;

    let result = '';
    if (d > 0) result += d + ' ';
    result += h;
    result += ':' + m;
    result += ':' + s;
    return result;
}

/**
 * 数字比例显示
 * @param value 原始数据
 * @param pos 精确位数
 * @param ratio 转换比例
 */
export const formatNum = function (value, pos = 2, ratio = 1) {
    if (empty(value)) return ' - ';
    return (value / ratio).toFixed(pos);
}

/**
 * 转换金额显示
 * @param value 原始数据
 */
export const formatMoney = function (value) {
    return formatNum(value, 2, 100);
}

/**
 * 转换金额显示
 * @param value 原始数据
 */
export const formatRealMoney = function (value) {
    return formatNum(value, 2);
}

/**
 * json编码
 */
export const jsonEncode = function (value) {
    return JSON.stringify(value);
}
/**
 * json解码
 */
export const jsonDecode = function (value) {
    try {
        return JSON.parse(value);
    } catch (e) {
        return false;
    }
}

/**
 *  数字转*号
 *  direction为真时，从 n 开始到倒数第 m 个
 *  direction为假时，从 n 开始替换 m 个
 */
export const numhid = function (num, n, m, direction) {
    let result = '';
    if (direction) {
        for (let i = 0; i < num.length; i++) {
            if (i > n && i < (num.length - m)) {
                result += '*';
            } else {
                result += num.charAt(i);
            }
        }
    } else {
        for (let i = 0; i < num.length; i++) {
            if (i > n && i <= n + m) {
                result += '*';
            } else {
                result += num.charAt(i);
            }
        }
    }
    return result;
}

/**
 * 定时器（严格按间隔执行）
 * @param {int} func 执行的方法
 * @param {int} interval 间隔/秒
 * @param {int} delay 延迟/秒
 */
export const moeTimer = function (func, interval, delay = 0) {
    let now = parseInt(new Date().getTime() / 1000);
    let time = now % interval;
    setTimeout(() => {
        setInterval(func, interval * 1000);
    }, time * 1000 + delay * 1000)
}

/**
 * 分钟转小时
 */
export const minuteToHour = function (value) {
    if (value) {
        let hours = Math.floor(value / 60);
        let minutes = value - hours * 60;
        return `${hours?hours+'小时':''}${minutes}分钟`
    } else {
        return ''
    }
}

/**
 * 秒转小时
 */
export const secondToHour = function (value) {
    if (value) {
        let hours = Math.floor(value / 3600);
        let minutes =  Math.floor((value - hours * 3600) / 60);
        let second = value - hours * 3600 - minutes * 60;
        return `${hours?hours+'小时':''}${minutes?minutes+'分钟':''}${second}秒`
    } else {
        return ''
    }
}

/**
 * 获取图片地址
 * @param url
 * @returns {string|null}
 */
export const filePath = function (url, type) {
    if (empty(url)) return null;
    if (url.indexOf('//') >= 0) {
        return url;
    } else {
        return (type == 'icon' ? '/static/icon/' : '/static/img/') + url;
        // return "https://api.nssxgh.cn" + (type == 'icon' ? '/static/wxxcx/gjkc_pc/icon/' : '/static/wxxcx/gjkc_pc/img/') + url;
    }
}

/**
 * 根据省份查询省份下的市
 */
export const getCityByProvinceId = function (provinceId) {
    if (!provinceId) return
    let cityList = [];
    for (let key in area.city_list) {
        let proinceSign = provinceId.slice(0, 2);
        let citySign = key.slice(0, 2);
        if (proinceSign == citySign) {
            cityList.push({
                cityId: key,
                cityName: area.city_list[key]
            })
        }
    }
    return cityList
}

/**
 * 数组对象去重
 */
export const uniqueByMap = function (arr, key) {
    const map = new Map();
    return arr.filter(item => {
        const keyValue = item[key];
        return map.has(keyValue) ? false : map.set(keyValue, true);
    });
}

/**
 * 评分转换（星转分）
 */
export const starToScore = function (value) {
    return value * 20
}

/**
 * 评分转换（分转星）
 */
export const scoreToStar = function (value) {
    return value / 20
}

/**
 * 手机号脱敏
 */
export const phoneHide = function (phone) {
    const reg = /^(\d{3})(\d{4})(\d{4})$/
    const text = phone.replace(reg, "$1****$3")
    return text
}

/**
 * 分钟转时分秒
 */

export const convertMinutesToCountdown = function (totalMinutes) {
    // 将分钟转换为秒
    let totalSeconds = totalMinutes;

    // 计算小时、分钟和秒
    let hours = Math.floor(totalSeconds / 3600); // 3600秒等于1小时
    let minutes = Math.floor((totalSeconds % 3600) / 60); // 剩余秒数除以60得到分钟数
    let seconds = totalSeconds % 60; // 剩余的秒数

    // 格式化输出为时分秒格式
    let countdown = `${hours?hours.toString().padStart(2, '0')+':':""}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    return countdown;
}

/**
 * 秒转分钟
 */
export const secondToMinute = function (seconds){
    return Math.floor(seconds/60)
}

/**
 * 秒转分钟
 */
export const secondToMinuteFormat = function (seconds){
    return Math.floor(seconds/60) + ":" + (seconds - Math.floor(seconds/60)*60);
}

/**
 * 秒转分钟
 */
export const secondToMinuteFormatNew = function (seconds){
    return Math.floor(seconds/60)?(Math.floor(seconds/60)+ "min"):''  + (seconds - Math.floor(seconds/60)*60) + "s";
}

// 秒格式换  小时：分钟：秒
export const formatSecondsToTime = function(seconds) {
    // 确保输入是数字且非负
    const totalSeconds = Math.floor(Number(seconds));
    if (isNaN(totalSeconds) || totalSeconds < 0) {
        return "00:00:00";
    }
    
    // 计算小时、分钟和秒
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    
    // 格式化为两位数，不足补零
    const formatNumber = (num) => num.toString().padStart(2, '0');
    
    return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(secs)}`;
}

/**
 * 格式化时间区间
 */
export const formatTimeInterval = function(startTime,endTime){
    let startDay = moment(startTime).format("MM月DD日");
    let endDay = moment(endTime).format("MM月DD日");
    let startHour = moment(startTime).format("HH:mm");
    let endHour = moment(endTime).format("HH:mm");
    if(startDay == endDay){
        return `${startDay} ${startHour}~${endHour}`
    }else{
        return `${startDay} ${startHour} ~ ${endDay} ${endHour}`
    }
}

/**
 * 富文本内容处理（限制图片宽）
 */
export const handlerImg = function(value){
    if(empty(value)) return
    value = value.replace(/<img\b([^>]*)>/gi, (match, attributes) => {
        // 1. 提取原有样式
        const styleMatch = attributes.match(/style\s*=\s*(["'])(.*?)\1/);
        let existingStyle = styleMatch ? styleMatch[2] : '';

        // 2. 添加/合并新样式（保留原有样式）
        if (!existingStyle.includes('max-width')) {
          existingStyle = `max-width:100%;height:auto;${existingStyle}`;
        } else {
          // 若已有max-width则仅补充height:auto
          existingStyle = existingStyle.replace(
            /max-width\s*:[^;]+;/i,
            '$&height:auto;'
          );
        }
        // 3. 替换或新增style属性
        return styleMatch
          ? match.replace(styleMatch[0], ` style="${existingStyle}"`)
          : match.replace(attributes, ` style="${existingStyle}" ${attributes}`);
      });
      return value
}

// base64转blob格式
export const base64ToBlob = function(base64Data) {
  // 分离MIME类型和Base64数据
  const parts = base64Data.split(';base64,');
  const contentType = parts[0].split(':')[1];
  const raw = window.atob(parts[1]);
  const uInt8Array = new Uint8Array(raw.length);
  
  for (let i = 0; i < raw.length; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  
  return new Blob([uInt8Array], { type: contentType });
}
